import { FilterOperator } from 'constants/filters/filter';

export const getFilterOperatorLabel = (operator: FilterOperator): string => {
  return operator === FilterOperator.Exclude ? 'is not' : 'is';
};
